import ValidationError from '@/errors/ValidationError'
import { dispatchEvent } from '@/helpers/DispatchEvent'

/**
 * Validates all `<input>` and `<select>` elements within the `container` element
 * by calling `checkValidity()` on each. If any fields are invalid, the page
 * automatically scrolls to the first invalid element.
 */
export function reportFormValidity(container: HTMLElement): Promise<void> {
  return Promise.resolve().then(() => {
    if (container) {
      const fields = container.querySelectorAll('input, select')

      for (const field of fields as NodeListOf<HTMLInputElement | HTMLSelectElement>) {
        const valid = field.checkValidity()
        if (!valid) {
          dispatchEvent('invalid', field)
        } else {
          dispatchEvent('validate', field)
        }
      }

      // Get the first invalid field.
      const field = container.querySelector('input:invalid, select:invalid') as HTMLInputElement | HTMLSelectElement
      if (field) {
        field.scrollIntoView()
        // Scroll up a bit more.
        window.scrollBy(0, -30)

        if (field.getAttribute('hidden') !== 'hidden') {
          field.focus()
        }

        throw new ValidationError()
      }
    }
  })
}

export function formIsValid(form: HTMLFormElement): boolean {
  const fields = form.querySelectorAll('input, select')

  for (const field of fields as NodeListOf<HTMLInputElement | HTMLSelectElement>) {
    if (!field.validity.valid) {
      return false
    }
  }

  return true
}
